import { QueryClient } from '@tanstack/react-query'

// Shared so that logging out can clear cached data outside of React components
export const queryClient = new QueryClient()
